var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTableRemoveRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium MuiBox-root",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H4C3.45 5 3 5.45 3 6V12C3 12.55 3.45 13 4 13H20C20.55 13 21 12.55 21 12V6C21 5.45 20.55 5 20 5ZM19 11H5V7H19V11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17H8V19H16V17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTableRemoveRow);
export default __webpack_public_path__ + "static/media/icon-table-remove-row.7fc73db59b50b6886dc155b99a708d89.svg";
export { ForwardRef as ReactComponent };